import { NavLink, Outlet } from 'react-router-dom';

import logo from '../../assets/svg/logo-bf.svg';
import logoFooter from '../../assets/svg/logo-white.svg';
import instagram from '../../assets/svg/instagram-bf.svg';
import youtube from '../../assets/svg/youtube-bf.svg';
import linkedin from '../../assets/svg/linkedin-bf.svg';

export function BlackFridayLayout() {
  return (
    <>
      <header className="flex items-center justify-start bg-black py-8 px-[138px] max-md:px-[100px] max-md:justify-center">
        <NavLink to="/">
          <img src={logo} alt="logo-header" />
        </NavLink>
      </header>
      <Outlet />
      <footer className="grid grid-cols-[25%_60%_15%] items-center bg-black py-8 px-[138px] max-md:grid-cols-1 max-md:px-6 max-md:pt-12 max-md:gap-6 md:max-lg:grid-cols-[30%_50%_20%] md:max-lg:px-[26px]">
        <NavLink to="/">
          <img src={logoFooter} alt="logo-footer" className="max-md:mx-auto" />
        </NavLink>
        <div className="flex items-center justify-between gap-16">
          <p className="font-normal text-sm leading-5 text-white pr-[9.5rem] max-md:pr-0 max-md:mb-6">
            Grupo Casas Bahia S.A. Rua Florida, 1970 - São Paulo - SP - CEP: 04565-001 CNPJ:
            33.041.260/0652-90
          </p>
        </div>
        <div className="flex items-center justify-center gap-[41px] max-md:mb-12 lg:gap-[25px]">
          <a
            href="https://www.instagram.com/grupocasasbahia/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram"
          >
            <img src={instagram} alt="Instagram" />
          </a>
          <a
            href="https://www.linkedin.com/company/viaimaginecaminhos"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={linkedin} alt="" />
          </a>
          <a
            href="https://www.youtube.com/c/ViaMarketplace"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={youtube} alt="" />
          </a>
        </div>
      </footer>
    </>
  );
}
